/**
 * Телефон покупателя — единственный разбор на все виджеты.
 *
 * До 24.08.2026 маска жила тремя копиями (калькулятор, чат, витрина) и была
 * сломана во всех трёх одинаково: обрезка до 11 цифр шла ДО нормализации.
 *
 * Как это выглядело у человека. Поле при фокусе подставляет «+7 ». Человек
 * вставляет номер из буфера целиком — «+7 900 123-45-67». В поле оказывается
 * два кода страны подряд, 12 цифр. `slice(0, 11)` отбрасывал ПОСЛЕДНЮЮ цифру,
 * а первая семёрка уезжала в тело номера: из «+79001234567» выходило
 * «+77900123456». Проверку сервера `^\+7\d{10}$` такой номер проходит — он
 * валидный, просто чужой. Менеджер звонил не туда, лид считался мусорным.
 *
 * Поэтому лишние коды страны снимаются СПЕРЕДИ и только потом идёт обрезка.
 *
 * Живёт здесь, а не в каждом виджете, потому что три копии одного правила уже
 * один раз разъехались — на ставках (`apps/api/src/lib/program-rates.ts`), и
 * стоило это расхождения платежа на экране и в CRM.
 */

/**
 * Цифры номера в канонический вид «7XXXXXXXXXX» (11 цифр).
 * Неполный ввод отдаётся как есть — маска рисует его по мере набора.
 */
export function normalizePhoneDigits(raw: string): string {
  let d = raw.replace(/\D/g, '');
  // Повторно введённый код страны: пока цифр больше 11 и первая — код, снимаем её.
  while (d.length > 11 && (d[0] === '7' || d[0] === '8')) d = d.slice(1);
  if (d.length === 0) return '';
  if (d[0] === '8') d = '7' + d.slice(1);
  else if (d[0] !== '7') d = '7' + d;
  return d.slice(0, 11);
}

/** Маска ввода `+7 (XXX) XXX-XX-XX`. */
export function formatPhone(raw: string): string {
  const d = normalizePhoneDigits(raw);
  if (d.length === 0) return '';
  if (d.length <= 1) return '+7 ';
  if (d.length <= 4) return `+7 (${d.slice(1)}`;
  if (d.length <= 7) return `+7 (${d.slice(1, 4)}) ${d.slice(4)}`;
  if (d.length <= 9) return `+7 (${d.slice(1, 4)}) ${d.slice(4, 7)}-${d.slice(7)}`;
  return `+7 (${d.slice(1, 4)}) ${d.slice(4, 7)}-${d.slice(7, 9)}-${d.slice(9, 11)}`;
}

/**
 * Строгий E.164 РФ `+7XXXXXXXXXX` для отправки на сервер, либо `null`.
 * Тот же нормализатор, что и у маски: иначе проверка пропускала бы номер,
 * который маска уже успела исказить.
 */
export function toPhoneE164(raw: string): string | null {
  const d = normalizePhoneDigits(raw);
  return /^7\d{10}$/.test(d) ? '+' + d : null;
}
